import React                       from "react";
import ReactDOM                    from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App                         from "./App";
import registerServiceWorker       from "./registerServiceWorker";
import { ThemeProvider }           from 'styled-components';
import config                      from "./config";
import Amplify, { Auth }           from 'aws-amplify';
import { WhiteLabel }              from "./utils/WhiteLabelProps";

import "./css/Index.css";
WhiteLabel();

const REACT_APP_COMPANY_LOGO    = sessionStorage.getItem('company_logo');
const REACT_APP_COMPANY_LOGO_SQ = sessionStorage.getItem('company_login_logo'); //process.env.REACT_APP_COMPANY_LOGO_SQ
const REACT_APP_S3_BUCKET_URL   = sessionStorage.getItem('s3_bucket_url');
const REACT_APP_S3_BUCKET_NAME  = sessionStorage.getItem('s3_bucket_name');

const REACT_APP_COMPANY_LOGO_URL = "https://" + REACT_APP_S3_BUCKET_URL + "/" + REACT_APP_S3_BUCKET_NAME + "/logos/" + REACT_APP_COMPANY_LOGO;

// Auth credentials
Amplify.configure({
    /* "API" is API Gateway credentials */
    API: {
        endpoints: [
          {
            name: "ts",
            endpoint: process.env.REACT_APP_API_GATEWAY_URL, //config.apiGateway.URL,
            region:   process.env.REACT_APP_API_GATEWAY_REGION  //config.apiGateway.REGION
          },
        ]
    },
    /* "AUTH" is cognito credentials */
    Auth: {
        mandatorySignIn: true,
        region:              process.env.REACT_APP_API_GATEWAY_REGION, //config.cognito.REGION,
        userPoolId:          process.env.REACT_APP_API_GATEWAY_USER_POOL_ID, //config.cognito.USER_POOL_ID,
        identityPoolId:      process.env.REACT_APP_API_GATEWAY_IDENTITY_POOL_ID, //config.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_API_GATEWAY_APP_CLIENT_ID  //config.cognito.APP_CLIENT_ID
    },
    /*Storage: {
        region: config.s3.REGION,
        bucket: config.s3.BUCKET,
        identityPoolId: config.cognito.IDENTITY_POOL_ID
    },*/
});

function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

var params = getSearchParameters();
var theme  = { mainColor: "#539d57", primary: 'white' };

ReactDOM.render(
    <ThemeProvider theme={ theme }>
        <Router>
          <App logo={REACT_APP_COMPANY_LOGO_URL}/>
        </Router>
     </ThemeProvider>,
     document.getElementById("root")
);
//window.LOG_LEVEL='DEBUG'; // detailed log level

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js